(function (ws) {
    'use strict';
    ws.collections.handsOnTableCollection = Backbone.Collection.extend({

        /**
         * Initialize function
         */
        initialize: function() {
            this.model = ws.models.handsOnTableModel;
            this.eventAgg = globals.eventAgg;
        },

        /**
         * Filter all bundle childs items
         * @returns {Array}
         */
        filterBundleChilds: function() {
            return _.filter(this.models, function(item) {
                return item.get('type') !== globals.bundles.ROLLUP_CHILD_BUNDLE_TYPE &&
                    item.get('type') !== globals.bundles.TOPDOWN_CHILD_BUNDLE_TYPE;
            });
        },

        /**
         * Filter the specified child items
         * @param {Array} childIds
         */
        filterBundleChildsByIds: function(childIds) {
            return _.filter(this.models, function(item) {
                return childIds.indexOf(item.get('id')) === -1;
            });
        },

        /**
         * Adds childs items again to the active collection
         * @param {Array} activeCollection
         * @param {Array} childIds
         */
        addBundleChilds: function(activeCollection, childIds) {
            _.each(childIds, function(childId) {
                var childModel = this.get(childId);
                var index = this.indexOf(childModel);

                activeCollection.add(childModel, {at: index, silent:true});
            }.bind(this));
        },

        /**
         * Updates parent model after child model update
         * @param {Object} data
         * @param {Object} updatedModel
         */
        updateParentModel: function(data, updatedModel) {
            if (updatedModel.get('parentEntryNumber') !== null && updatedModel.get('parentEntryNumber') !== 0) {
                var parent = this.get(updatedModel.get('parentEntryNumber') / 10);
                var parentResponse = _.find(data, function (item) {
                    return item.id === parent.get('id');
                });

                parent.set(parentResponse, {silent: true});
            }
        },

        /**
         * Updates Bundel models after child model update
         * @param {Object} data
         */
        updateBundleModels: function(data) {
            var _this = this;
            _.each(data, function(item) {
                var itemModel = _this.get(item.id);
                itemModel.set(item, {silent:true});
            });
        },

        /**
         * Updates child models after parent model update
         * @param {Object} data
         * @param {Object} updatedModel
         */
        updateChildModels: function(data, updatedModel) {
            if (updatedModel.get('childs') !== null) {
                var childs = _.filter(this.models, function (item) {
                    return updatedModel.get('childs').indexOf(item.get('id')) !== -1;
                });

                _.each(childs, function (child) {
                    var childResponse = _.find(data, function (childItem) {
                        return childItem.id === child.get('id');
                    });

                    child.set(childResponse, {silent: true});

                });
            }
        },

        /**
         * Removes parent model from collection within its childs
         * @param {Object} model
         */
        removeWithChilds: function(model) {
            _.each(this.getBundleChilds(model.get('childs')), function(item) {
                this.remove(item);
            }.bind(this));

            this.remove(model);
        }

    });
})(westcon);
